import { createContext } from 'react';
import { Slots } from './Slots';

export type GenericSlotProps = Slots;
export type SlotContextValue = GenericSlotProps;

export const SlotContext = createContext<SlotContextValue | undefined>(
    undefined,
);

export const SlotProvider = SlotContext.Provider;
